import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import axios from 'axios'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { initUtil, client } from './util'
import { loadToken } from './client'

library.add(faSignOutAlt)
library.add(faDownload)
library.add(faSpinner)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

Vue.use(VueCompositionApi)

axios.get("/config.json")
  .then((response) => {

      initUtil(response.data.backendUrl);

      client.token = loadToken();

      new Vue({
        router,
        render: h => h(App)
      }).$mount('#app');
  })
  .catch((error) => {
    console.log(error);
    alert("configuration error");
  });
